<template>
  <portal selector="#fullscreen-portal-target">
    <div id="image-viewer" class="pos-fixed pos-top-center">
      <div class="pos-absolute pos-top-right mx-2 mt-2 c-pointer z-1" @click="close()">
        <i class="fa-solid fa-xmark fa-2x fg-white"></i>
      </div>
      <div class="h-100 p-2">
        <img :src="url" alt="" class="w-100 h-100" style="object-fit: scale-down">
      </div>
    </div>
  </portal>
</template>

<script>
import { Portal } from '@linusborg/vue-simple-portal'

export default {
  name: "image-viewer",
  props: {
    url: {
      type: String,
      required: true
    }
  },
  components: {
    Portal
  },
  destroyed() {
    this.$store.commit('SET_FULLSCREEN_COMPONENT', false)
    $(".app-block").css("overflow", "scroll")
  },
  mounted() {
    this.$store.commit('SET_FULLSCREEN_COMPONENT', true)
    $(".app-block").css("overflow", "hidden")
  },
  computed: {
    fullscreenComponent() {
      return this.$store.getters.fullscreenComponent
    }
  },
  methods: {
    close() {
      this.$emit('close-image-viewer')
    }
  },
  watch: {
    fullscreenComponent(newVal) {
      if (!newVal) {
        this.close()
      }
    }
  }
}
</script>

<style scoped>
#image-viewer {
  background-color: rgba(33,31,31,0.95);
  height: calc(var(--vh) * 100 - var(--safe-area-inset-top) - var(--safe-area-inset-bottom));
  width: 100%;
  margin-top: var(--safe-area-inset-top);
  margin-bottom: var(--safe-area-inset-bottom);
}
</style>